module.exports = "/images/arrow-up-white.png?ed40b60dca6b7faf6fb415c6c8d35023";